import { WritableDraft } from 'immer'

type Item<T> = WritableDraft<T> & { id: number }

export function updateOrAddArrayItem<T extends Item<T>>(item: T, array?: WritableDraft<T>[]) {
  if (!array) {
    return
  }
  const index = array.findIndex(({ id }) => id === item.id)
  if (index !== -1) {
    array[index] = item
  } else {
    array.push(item)
  }
}

export function updateOrAddArray<T extends Item<T>>(newArray: T[], array?: WritableDraft<T>[]) {
  if (!array) {
    return
  }
  newArray.forEach((item) => {
    updateOrAddArrayItem(item, array)
  })
}

export function removeItem<T extends Item<T>>(id: number, array?: WritableDraft<T>[]) {
  if (!array) {
    return
  }
  const index = array.findIndex((item) => id === item.id)
  if (index !== -1) {
    array.splice(index, 1)
  }
}

export function updateOrAddItem<T>(
  array: WritableDraft<T>[],
  predicate: (item: WritableDraft<T>) => boolean,
  item: WritableDraft<T>,
) {
  const index = array.findIndex(predicate)
  if (index !== -1) {
    array[index] = item
  } else {
    array.push(item)
  }
}
